var _use, _use2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockupWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "27.68479mm",
    height: "27.68479mm",
    viewBox: "0 0 27.68479 27.68479",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1106"
  }, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "m 4.34375,-8.46875 c 1.125,0 1.328125,0.765625 1.328125,2.140625 0,1.34375 -0.203125,2.15625 -1.328125,2.15625 -0.125,0 -0.296875,0 -0.390625,-0.046875 V -8.421875 C 4.078125,-8.46875 4.21875,-8.46875 4.34375,-8.46875 Z M 10.875,-6.921875 H 9.15625 v -1.46875 h 2.03125 v -1.0625 H 7.90625 V -3.21875 H 11.1875 V -4.25 H 9.15625 V -5.890625 H 10.875 Z m -6.625,3.78125 c 1.9375,0 2.671875,-0.984375 2.671875,-3.1875 0,-2.140625 -0.6875,-3.21875 -2.625,-3.21875 -0.421875,0 -1.03125,0.09375 -1.59375,0.171875 v 6.15625 c 0.5625,0.078125 1.203125,0.078125 1.546875,0.078125 z m 8.046875,-6.3125 c -0.125,1.5 -0.25,4.203125 -0.296875,6.234375 h 1.203125 c 0,-1.46875 0.04687,-3.015625 0.07813,-4.484375 h 0.04687 l 0.859375,3.53125 h 1.15625 l 0.875,-3.53125 c 0.07813,1.46875 0.125,3.015625 0.125,4.484375 h 1.25 C 17.5,-5.25 17.421875,-7.953125 17.328125,-9.453125 h -1.71875 l -0.8125,3.4375 -0.828125,-3.4375 z m 8.421875,6.3125 c 1.734375,0 2.328125,-0.984375 2.328125,-3.1875 0,-2.1875 -0.59375,-3.21875 -2.328125,-3.21875 -1.71875,0 -2.265625,1.03125 -2.265625,3.21875 0,2.203125 0.546875,3.1875 2.265625,3.1875 z m 0,-5.328125 c 0.90625,0 1.078125,0.734375 1.078125,2.140625 0,1.390625 -0.171875,2.15625 -1.078125,2.15625 -0.859375,0 -1.03125,-0.765625 -1.03125,-2.15625 0,-1.40625 0.171875,-2.140625 1.03125,-2.140625 z m -0.421875,-12.859375 c -3.5625,0 -6.703125,8.046875 -6.703125,8.046875 1.796875,-1.765625 4.03125,-2.75 7.125,-3.109375 0.90625,-0.125 2.25,-0.890625 2.25,-2.234375 0,-0.890625 -0.4375,-2.703125 -2.671875,-2.703125 z m -14.3125,2.234375 c -1.765625,0 -2.671875,1.328125 -2.671875,2.703125 0,1.34375 1.328125,2.25 2.671875,2.25 2.703125,0 4.9375,0.859375 6.703125,3.09375 0,0 -2.671875,-8.046875 -6.703125,-8.046875 z M 13.5,-25.5 c -1.28125,-1.25 -2.875,-0.90625 -3.828125,0.04687 -0.90625,0.984375 -0.5625,2.53125 0.390625,3.484375 1.9375,1.84375 2.921875,4.078125 2.625,6.921875 0,0 3.703125,-7.65625 0.8125,-10.453125 z m 0,0",
    id: "path1097"
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "m 2.15625,-14.96875 c 0,8.6875 6.75,15.40625 15.609375,15.40625 6.0625,0 9.328125,-2.71875 10.484375,-3.828125 0.515625,-0.484375 0.90625,-1.171875 0.90625,-1.9375 0,-1.296875 -0.953125,-2.234375 -2.28125,-2.234375 -0.6875,0 -1.296875,0.34375 -1.765625,0.71875 -1.203125,1.078125 -3.265625,2.71875 -7.265625,2.71875 -6.109375,0 -10.75,-4.734375 -10.75,-10.921875 0,-6.1875 4.640625,-10.921875 10.75,-10.921875 3.921875,0 6.0625,1.671875 7.015625,2.40625 0.46875,0.34375 1.03125,0.59375 1.671875,0.59375 1.25,0 2.28125,-0.9375 2.28125,-2.265625 0,-0.90625 -0.46875,-1.6875 -1.328125,-2.28125 C 26.09375,-28.546875 23,-30.53125 17.9375,-30.53125 c -8.859375,0 -15.78125,6.875 -15.78125,15.5625 z m 0,0",
    id: "path1100"
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "m 3.875,-2.5 c 0,1.46875 1.03125,2.5 2.484375,2.5 H 22.53125 c 1.296875,0 2.1875,-0.90625 2.1875,-2.234375 0,-1.296875 -0.890625,-2.1875 -2.1875,-2.1875 H 8.8125 v -23.4375 c 0,-1.421875 -1.03125,-2.453125 -2.453125,-2.453125 -1.453125,0 -2.484375,1.03125 -2.484375,2.453125 z m 0,0",
    id: "path1103"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-108.62189,-45.310878)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1.76389,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1
    },
    d: "m 115.85384,46.192823 c -3.50711,0 -6.35,2.842891 -6.35,6.35 v 13.220899 c 0,3.507108 2.84289,6.35 6.35,6.35 h 13.2209 c 3.50711,0 6.35,-2.842892 6.35,-6.35 V 52.542823 c 0,-3.507109 -2.84289,-6.35 -6.35,-6.35 z m 0,0",
    id: "path1112"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.0423333,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1
    },
    d: "m 116.38025,56.579097 c 0,3.060623 2.37711,5.423959 5.49837,5.423959 2.13596,0 3.288,-0.953603 3.69728,-1.347722 0.1819,-0.166743 0.31695,-0.409277 0.31695,-0.682129 0,-0.454753 -0.33211,-0.78686 -0.80202,-0.78686 -0.24254,0 -0.45475,0.121268 -0.6215,0.256316 -0.42443,0.37896 -1.15066,0.95498 -2.56039,0.95498 -2.15112,0 -3.78685,-1.666048 -3.78685,-3.847483 0,-2.181435 1.63573,-3.848861 3.78685,-3.848861 1.37941,0 2.13596,0.591179 2.46944,0.848872 0.16675,0.121267 0.3638,0.212218 0.59118,0.212218 0.4396,0 0.8034,-0.333485 0.8034,-0.803397 0,-0.318326 -0.16675,-0.591178 -0.46991,-0.803396 -0.48507,-0.363802 -1.5751,-1.059712 -3.36379,-1.059712 -3.12126,0 -5.55901,2.42397 -5.55901,5.483215 z m 0,0",
    id: "path1114"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "g1118",
    transform: "matrix(0.35277778,0,0,0.35277778,97.064286,33.753274)"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 52.605099,
    y: 79.650002,
    id: "use1116",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.0423333,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1
    },
    d: "m 121.07798,66.268084 c 0,0.515386 0.3638,0.879188 0.87919,0.879188 h 5.69543 c 0.45475,0 0.77308,-0.318326 0.77308,-0.788238 0,-0.454752 -0.31833,-0.771701 -0.77308,-0.771701 h -4.83278 v -8.257205 c 0,-0.500228 -0.3638,-0.862652 -0.86265,-0.862652 -0.51539,0 -0.87919,0.362424 -0.87919,0.862652 z m 0,0",
    id: "path1120"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "g1124",
    transform: "matrix(0.35277778,0,0,0.35277778,97.064286,33.753274)"
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 64.205101,
    y: 94.660202,
    id: "use1122",
    width: "100%",
    height: "100%"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockupWhite);
export default __webpack_public_path__ + "static/media/lockup-white.a8be2e63ca663158a8eb087a1a80c221.svg";
export { ForwardRef as ReactComponent };